import './../products/products.scss'
import { SearchOutlined,SisternodeOutlined,CalendarOutlined,WhatsAppOutlined,UserOutlined,CloseOutlined,ArrowDownOutlined, ArrowUpOutlined,CloseCircleOutlined, CheckCircleOutlined,DollarOutlined,DeleteOutlined} from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { Button, Space, Popover, Popconfirm, Tag, Input, message } from 'antd';
import axios from 'axios';
import config from '../../config';
import { useSelector } from 'react-redux';
import canSeeFinance from '../../utils/canSeeFinance';
import DetteSelect from './DetteSelect';
import { format } from 'date-fns';
import moment from 'moment';
import CountUp from 'react-countup';
import { NdoeResponsiveTable } from '../../components/ndoe';

const DetteJour7 = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const scroll = { x: 450 };
    const [open, setOpen] = useState(false);
    const [recent, setRecent] = useState([]);
    const [opens, setOpens] = useState(false);
    const [idClient, setIdClient] = useState({});
    const user = useSelector((state) => state.user?.currentUser);
    


      // DEUX DÉFAUTS ICI, CORRIGÉS LE 10/08/2026.
      //
      // 1. L'IDENTIFIANT ÉTAIT REÇU MAIS JAMAIS ENVOYÉ. La route est
      //    `DELETE /vente/dette/:id` : sans lui, l'appel partait sur une adresse
      //    inexistante, tombait en 404, et la dette restait. Le clic ne
      //    produisait RIEN — pas même un message.
      //
      // 2. L'ÉCHEC PARTAIT DANS LA CONSOLE. Or le serveur refuse délibérément
      //    de supprimer une dette liée à des paiements (409 : « annulez d'abord
      //    les paiements »). Ce refus est une règle de gestion, pas un incident :
      //    il doit être LU, pas avalé.
      const handleDelete = async (id) => {
        if (!id) { message.error('Dette introuvable.'); return; }
        try {
          await axios.delete(`${DOMAIN}/api/vente/vente/dette/${id}`);
          message.success('Dette supprimée.');
          window.location.reload();
        } catch (err) {
          message.error(err.response?.data?.error || 'La suppression a échoué.');
        }
      };

      const HandOpen = () => {
        setOpens(!opens);
      };
    
      const columns = [
        { title: '#', dataIndex: 'id', key: 'id', render: (text, record, index) => index + 1},
        {
          title: 'Code',
          dataIndex: 'id_commande',
          key: 'id_commande',
          render: (text, record) => (
            <Tag color="blue">{`${new Date().getFullYear().toString().substring(2)}${record.id_shop.toString().padStart(2, '0')}${record.id_commande.toString().padStart(4, '0')}`}</Tag>
          ),
        },
        {
          title: 'NomDelaClient',
          dataIndex: 'nom',
          key: 'nom',
          render : (text,record)=>(
            <div onClick={()=> handleOk(record.id_client)} style={{cursor: 'pointer'}}>
              <Tag color={'blue'}>
              <UserOutlined style={{ marginRight: "5px" }} />
              {text}
              </Tag>
            </div>
          )
        },
        {
            title: 'Telephone',
            dataIndex: 'telephone',
            key: 'email',
            render: (text) => (
              <Popover content="Discutez avec lui sur WhatsApp" placement="top">
              <Tag
                onClick={() => window.open(`https://wa.me/${text}`, '_blank')}
                color="green"
                style={{ cursor: 'pointer' }}
              >
                <WhatsAppOutlined style={{ color: 'green', marginRight: '5px' }} />
                {text}
              </Tag>
            </Popover>
            ),
          },
          {
            title: 'Montant facture',
            dataIndex: 'montant_convenuV',
            key: 'montant_convenu',
            sorter: (a, b) => a.montant_convenuV - b.montant_convenuV,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => (
              <Tag color="blue" icon={<DollarOutlined />}>
                {record.montant_convenuV.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </Tag>
            ),
          },
        {
          title: 'Montant payé',
          dataIndex: 'montant_payeV',
          key: 'montant_payeV',
          sorter: (a, b) => a.montant_payeV - b.montant_payeV,
          sortDirections: ['descend', 'ascend'],
          render: (text, record) => (
            <Tag color="blue" icon={<DollarOutlined />}>
              {record.montant_payeV.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
              })}
            </Tag>
          ),
        },
          {
            title: 'Montant restant',
            dataIndex: 'montant_restant',
            key: 'montant_restant',
            sorter: (a, b) => a.montant_restant - b.montant_restant,
            sortDirections: ['descend', 'ascend'],
            render: (text, record) => {
              let icon;
          
              if (record.montant_restant > 0) {
                icon = <ArrowUpOutlined />;
              } else if (record.montant_restant < 0) {
                icon = <ArrowDownOutlined />;
              } else {
                icon = null;
              }
          
              return (
                <Tag color={record.montant_restant === 0 ? 'green' : 'red'} icon={icon}>
                  {record.montant_restant.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                  })}
                </Tag>
              );
            },
          },
          {
            title: 'Date',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text) => {
              const formattedDate = format(new Date(text), 'dd-MM-yyyy');
              return <Tag color={'blue'} icon={<CalendarOutlined />}>
                      {formattedDate}
                     </Tag>;
            },
        },
          {
            title: 'Statut',
            dataIndex: 'statut',
            key: 'statut',
            render: (text) => (
              <Tag color={text === 'Validé' ? 'green' : 'red'}>
                {text === 'Validé' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                &nbsp; {text }
              </Tag>
            ),
          },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                
              <Space size="middle">
                {user?.role === 'admin' &&
                <Popover title="Supprimer" trigger="hover">
                  <Popconfirm
                    title="Êtes-vous sûr de vouloir supprimer?"
                    onConfirm={() => handleDelete(record.id_dette)}
                    okText="Oui"
                    cancelText="Non"
                  >
                    <Button icon={<DeleteOutlined />} style={{ color: 'red' }} />
                  </Popconfirm>
                </Popover>}
              </Space>
            ),
          },
      ];

      const financeColumnKeys = ['montant_convenu', 'montant_payeV', 'montant_restant'];
      const visibleColumns = canSeeFinance(user)
        ? columns
        : columns.filter((col) => !financeColumnKeys.includes(col.key));

      useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/vente/vente/detteJour7`);
            setData(data);
            setLoading(false)
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN]);

      useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/vente/vente/detteRapport7jours`);
            setRecent(data);
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN]);


    const handleOk = async (e) => {
      setOpen(true)
      setIdClient(e)
    };

  const filteredData = data?.filter((item) =>
  item.nom?.toLowerCase().includes(searchValue.toLowerCase())
);

  return (
    <>
        <div className="products">
            <div className="product-container">
                <div className="product-bottom">
                    <div className="product-bottom-top">
                        <div className="product-bottom-left">
                          {opens ?<CloseOutlined className='product-icon2' onClick={HandOpen} /> : <SisternodeOutlined className='product-icon' onClick={HandOpen} />}
                          <Input
                              type="search"
                              value={searchValue}
                              onChange={(e) => setSearchValue(e.target.value)}
                              placeholder="Recherche..."
                              className="product-search"
                            />
                        </div>
                        <div className="product-bottom-right">
                        </div>
                    </div>
                    {opens &&
                    <DetteSelect getProduits={setData}/> }
                    <div className="rowChart-row-table">
                        <NdoeResponsiveTable columns={visibleColumns} data={filteredData} loading={loading} scroll={scroll} pagination={{ pageSize: 10}} />
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default DetteJour7